export default [
    {
        path: '/accounts',
        name: 'accounts',
        component: () => import('@/views/accounts/accounts-list/index.vue')
    },
    {
        path: '/accounts/:uuid',
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'accounts_uuid',
                component: () => import('@/views/accounts/accounts-details/index.vue')
            },
            {
                path: 'view',
                name: 'accounts_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            },
            {
                path: 'account-documentation-uuid-view',
                name: 'account_documentation_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            }
            // {
            //     path      : 'edit',
            //     name      : 'accounts_uuid_edit',
            //     component : () => import('@/views/accounts/accounts-details/index.vue')
            // }
        ]
    }
];
